export default __webpack_public_path__ + "static/media/marker-icon-black.d19388e1.png";